<template>
  <div class="app">
    <AppHeader  class="bg-header" fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" :src="`${$store.state.app_url}/img/logo_orange.png`" width="45" height="45" alt="Logo Orange">
        
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      
      <b-navbar-nav class="ml-auto">
              <b-nav-item color="#ffff" class="d-md-down-none menu-item" @click="$router.push('/pages/home')">
              <b-link class="text-white">
                <i class="icon-home"></i>
                  Accueil
                </b-link>
              </b-nav-item>
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar class="bg-org" fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer class="bg-org"/>
      </AppSidebar>
      <main class="main bg-white">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <transition name="fade">
            <router-view></router-view>
          </transition>
        </div>
      </main>
      
    </div>
    <TheFooter>
     
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

export default {
  name: 'full',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      nav: nav.items
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  }
}
</script>

<style>
 .menu-item{
    padding-right:20px 
  }
</style>
